// Drop Utils
import preventAnyElementPredicate from '../../../../../element/dnd/canDrop/preventAnyElementPredicate';
import preventAllElementPredicate from '../../../../../element/dnd/canDrop/preventAllElementPredicate';
import makeCanDropFn from '../../../../../element/dnd/canDrop/makeCanDropFn';
import { isBoardLike, isLine, isColumn, isAnnotation } from '../../../../../../common/elements/utils/elementTypeUtils';

const quickNotesCanDrop = makeCanDropFn([
    preventAnyElementPredicate([isBoardLike, isColumn]),
    preventAllElementPredicate([isLine, isAnnotation]),
]);

export default quickNotesCanDrop;
